import React from 'react';
import { Link } from 'react-router-dom';

export default function About() {
    return (
        <div className="section">
            <div className="eyebrow">About</div>
            <div style={{display:'grid', gridTemplateColumns:'1.1fr 0.9fr', gap:'18px', alignItems:'start'}} className="about-hero">
                <div>
                    <h1 style={{fontSize:'2.2rem', fontWeight:900, letterSpacing:'-0.03em', color:'#0f172a', lineHeight:1}}>Bechir Dridi<br/><span style={{background:'linear-gradient(90deg,#f59e0b,#06b6d4)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent'}}>Full Stack & GenAI Developer</span></h1>
                    <p style={{marginTop:'12px', color:'#475569', fontSize:'1.02rem', lineHeight:1.65}}>
                        Aeronautical Engineer turned software builder. I help businesses ship <strong>scalable web & desktop apps</strong> with React, Vue, Node and Laravel — now supercharged with <strong>LangChain, Hugging Face & OpenAI</strong>.
                        I love turning messy ideas into clean, fast, maintainable products.
                    </p>
                    <div style={{display:'flex', gap:'10px', marginTop:'16px', flexWrap:'wrap'}}>
                        <a href="mailto:b7dridi@gmail.com" className="btn btn-primary">Email me</a>
                        <a href="https://github.com/Bechir-Dridi" target="_blank" rel="noreferrer" className="btn btn-ghost">GitHub</a>
                        <a href="https://www.linkedin.com/in/bechir-dev/" target="_blank" rel="noreferrer" className="btn btn-ghost">LinkedIn</a>
                    </div>
                    <div style={{marginTop:'18px', display:'flex', gap:'12px', flexWrap:'wrap', fontSize:'0.88rem', color:'#64748b'}}>
                        <span>📞 +216 52 98 30 99</span><span>•</span><span>✉️ b7dridi@gmail.com</span>
                    </div>
                </div>
                <div style={{background:'white', border:'1px solid #e2e8f0', borderRadius:'18px', padding:'18px', boxShadow:'0 8px 30px rgba(15,23,42,0.07)'}}>
                    <h3 style={{fontWeight:800, color:'#0f172a'}}>At a glance</h3>
                    <ul style={{marginTop:'10px', display:'grid', gap:'8px', fontSize:'0.92rem', color:'#334155'}}>
                        <li>• 4+ years building React/Vue + Node/Laravel products</li>
                        <li>• Desktop apps with Electron & Tauri (MCQ Magician, Chart Master)</li>
                        <li>• GenAI: LangChain, HF, OpenAI APIs — quiz gen, chat, RAG</li>
                        <li>• Former Database Admin (MySQL, automation) & IT Technician</li>
                        <li>• Freelance since 2021 — SEO-friendly sites & dashboards</li>
                    </ul>
                    <div style={{marginTop:'14px', padding:'12px', background:'#f8fafc', borderRadius:'12px', border:'1px solid #e2e8f0'}}>
                        <div style={{fontFamily:'JetBrains Mono, monospace', fontSize:'0.72rem', fontWeight:700, letterSpacing:'0.08em', color:'#f59e0b'}}>LANGUAGES</div>
                        <div style={{fontSize:'0.86rem', marginTop:'4px', color:'#334155'}}>Arabic (Native) • English (Professional) • French (Professional) • German (A1)</div>
                    </div>
                </div>
            </div>

            <div style={{marginTop:'28px'}}>
                <h2 style={{fontSize:'1.4rem', fontWeight:800, color:'#0f172a'}}>Technical skills</h2>
                <div className="skills-grid" style={{marginTop:'12px'}}>
                    <div className="skill-card"><h3>Frontend</h3><p>HTML5, CSS3, JS/TS, React, Next.js, Vue, Redux, Tailwind, Bootstrap, WordPress</p></div>
                    <div className="skill-card"><h3>Backend</h3><p>Node, Express, PHP, Laravel, Python, FastAPI, C#, ASP.NET, Prisma</p></div>
                    <div className="skill-card"><h3>Databases</h3><p>MySQL, PostgreSQL, SQLite, MongoDB, Firebase, Supabase, Cloudinary</p></div>
                    <div className="skill-card"><h3>GenAI & ML</h3><p>LangChain, Hugging Face, OpenAI API</p></div>
                    <div className="skill-card"><h3>Mobile & Desktop</h3><p>React Native, Capacitor, Electron.js, Tauri</p></div>
                    <div className="skill-card"><h3>ERP & Tools</h3><p>Microsoft Dynamics, SAP (ABAP Basics), Git, Docker, Figma, Canva</p></div>
                </div>
            </div>

            <div style={{marginTop:'28px'}}>
                <h2 style={{fontSize:'1.4rem', fontWeight:800, color:'#0f172a'}}>Experience</h2>
                <div className="timeline" style={{marginTop:'12px'}}>
                    <div className="timeline-item">
                        <div className="timeline-date">Oct 2024 — Present</div>
                        <div>
                            <h3>Full Stack Developer — NET HAWKS</h3>
                            <p>Built cross-platform productivity apps <strong>MCQ Magician</strong> and <strong>Chart Master</strong> used by internal teams. React/Vue frontends, REST APIs, deployed desktop apps with Electron & Tauri for Windows/Linux. Worked closely with product teams on UX iteration.</p>
                        </div>
                    </div>
                    <div className="timeline-item">
                        <div className="timeline-date">Jun 2022 — Aug 2024</div>
                        <div>
                            <h3>Database Administrator — Baraka Agro</h3>
                            <p>Managed warehouse MySQL databases ensuring integrity & performance. Built PHP automation scripts, handled backups and proactive issue resolution.</p>
                        </div>
                    </div>
                    <div className="timeline-item">
                        <div className="timeline-date">Oct 2021 — Present</div>
                        <div>
                            <h3>Freelance Full Stack Web Developer — Self-Employed</h3>
                            <h4>Remote</h4>
                            <p>Delivered SEO-friendly sites & dashboards end-to-end (Laravel, React, MySQL) with Firebase/OAuth integrations for local businesses. Consistent client satisfaction.</p>
                        </div>
                    </div>
                    <div className="timeline-item">
                        <div className="timeline-date">Jan 2020 — May 2022</div>
                        <div>
                            <h3>IT Technician — Bizerte Motors</h3>
                            <p>Installed & maintained Linux systems across 50+ workstations, routine maintenance and troubleshooting.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{marginTop:'28px', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px'}} className="edu-grid">
                <div style={{background:'white', border:'1px solid #e2e8f0', borderRadius:'14px', padding:'16px'}}>
                    <h3 style={{fontWeight:800, color:'#0f172a'}}>Education</h3>
                    <p style={{marginTop:'6px', fontWeight:700, color:'#334155'}}>Bachelor's in Aeronautical Engineering</p>
                    <p style={{color:'#64748b', fontSize:'0.9rem'}}>ESAT University — Tunis, Tunisia</p>
                </div>
                <div style={{background:'white', border:'1px solid #e2e8f0', borderRadius:'14px', padding:'16px'}}>
                    <h3 style={{fontWeight:800, color:'#0f172a'}}>Key projects (highlight)</h3>
                    <ul style={{marginTop:'6px', fontSize:'0.92rem', color:'#334155', display:'grid', gap:'4px'}}>
                        <li>• <strong>MCQ Magician</strong> — AI quiz desktop app (Electron + LangChain)</li>
                        <li>• <strong>Chart Master</strong> — Visualization desktop app (Tauri + React)</li>
                        <li>• <strong>USMLE Pulse</strong> — Med exam platform (Next + Supabase + FastAPI)</li>
                    </ul>
                </div>
            </div>

            <div style={{marginTop:'22px'}} className="cta">
                <div><h3>Let's work together</h3><p>Open for freelance & full-time roles. Reach out and get a reply within 24h.</p></div>
                <Link to="/contact" className="btn" style={{background:'#f59e0b', color:'white'}}>Contact now →</Link>
            </div>
        </div>
    )
}
